module.exports = __webpack_public_path__ + "static/media/21-active.12be2f43.png";